export const Environments = {
  DEV: 'development',
  PROD: 'production',
  REVIEW: 'review'
};

export const MAX_ATTACHMENT_FILE_SIZE_IN_BYTES = 20 * 1000 * 1000; // 20MB
export const MAX_ATTACHMENT_FILE_SIZE_IN_MEGABYTES_STRING = '20MB';
